import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import Fade from '@mui/material/Fade';

import FRI1 from './FRI1.png';
import FRI2 from './FRI2.png';
import FRI3 from './FRI3.png';
import FRI41 from './FRI4-1.png';
import FRI42 from './FRI4-2.png';
import FRI43 from './FRI4-3.png';
import FRI5 from './FRI5.png';
import FRI61 from './FRI6-1.png';
import FRI62 from './FRI6-2.png';

import Loading from '../../common/Loading';
import Error from '../../common/Error';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function LoadListInspectionView(props) {
    //console.debug("RTS Break LoadListInspectionView");

    const {userAuthToken, apiRoot, userLogOut} = useSessionContext();
        
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [data, setData] = useState([]);

    const formatObj = new Intl.DateTimeFormat("en-US");    
 
    const [showZoomModal, setShowZoomModal] = useState(false);
    const [zoomTitle, setZoomTitle] = useState("Image Zoom");
    const [zoomMode, setZoomMode] = useState(null);


    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/ReelInspections/GetReelInspectionById/" + pFilter;
        axios
        .get(
            apiURL,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status === 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token]); 


    useEffect(() => {
            fetchData(props.idGuid);
    }, [props, fetchData]); 


    function setZoom(mode){
        switch(mode){
            case 'FRI1':
                setZoomTitle('Cracks in the ribs of the flange');
                break;
            case 'FRI2':
                setZoomTitle('Abrasions in the flange');
                break;
            case 'FRI3':
                setZoomTitle('Burs on the lagging tire');
                break;
            case 'FRI41':
                setZoomTitle('Damages to crossarms and arbor');
                break;
            case 'FRI42':
                setZoomTitle('Damages to crossarms and arbor');
                break;
            case 'FRI43':
                setZoomTitle('Damages to crossarms and arbor');
                break;
            case 'FRI5':
                setZoomTitle('Straightness of Reel');
                break;
            case 'FRI61':
                setZoomTitle('Two D-rings in the starter pocket');
                break;
            case 'FRI62':
                setZoomTitle('Two gussets on crossarm');
                break;
            default:
                setZoomTitle('Unknown Value');
                break;
        }

        setZoomMode(mode);
        setShowZoomModal(true);        
    }


    if(hasError){
        return(
            <Error />
        );
    };


    if(isLoading){
        return(
            <Loading />
        );
    };


    return (
        <>
        <Dialog open={showZoomModal} onClose={()=>{setShowZoomModal(false);}}>
            <DialogTitle>{zoomTitle}</DialogTitle>
            <DialogContent>
                {
                    zoomMode==='FRI1'
                    ?
                        <Fade in>
                            <Box component="img" src={FRI1} sx={{ width: "500px" }} />
                        </Fade>
                        // <Image src={FRI1} showLoading width={500} />
                    :
                    zoomMode==='FRI2'
                    ?               
                        <Fade in>
                            <Box component="img" src={FRI2} sx={{ width: "500px" }} />
                        </Fade>
                        // <Image src={FRI2} showLoading width={500} />
                    :
                    zoomMode==='FRI3'
                    ?               
                        <Fade in>
                            <Box component="img" src={FRI3} sx={{ width: "500px" }} />
                        </Fade>
                        // <Image src={FRI3} showLoading width={500} />
                    :
                    zoomMode==='FRI41'
                    ?               
                        <Fade in>
                            <Box component="img" src={FRI41} sx={{ width: "500px" }} />
                        </Fade>
                        // <Image src={FRI41} showLoading width={500} />
                    :
                    zoomMode==='FRI42'
                    ?               
                        <Fade in>
                            <Box component="img" src={FRI42} sx={{ width: "500px" }} />
                        </Fade>
                        // <Image src={FRI42} showLoading width={500} />
                    :
                    zoomMode==='FRI43'
                    ?               
                        <Fade in>
                            <Box component="img" src={FRI43} sx={{ width: "500px" }} />
                        </Fade>
                        // <Image src={FRI43} showLoading width={500} />
                    :
                    zoomMode==='FRI5'
                    ?               
                        <Fade in>
                            <Box component="img" src={FRI5} sx={{ width: "500px" }} />
                        </Fade>
                        // <Image src={FRI5} showLoading width={500} />
                    :
                    zoomMode==='FRI61'
                    ?               
                        <Fade in>
                            <Box component="img" src={FRI61} sx={{ width: "500px" }} />
                        </Fade>
                        // <Image src={FRI61} showLoading width={500} />
                    :
                    zoomMode==='FRI62'
                    ?               
                        <Fade in>
                            <Box component="img" src={FRI62} sx={{ width: "500px" }} />
                        </Fade>
                        // <Image src={FRI62} showLoading width={500} />
                    :
                        ''
                }
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowZoomModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Box>
            <Stack>
                <Box sx={{display:'flex'}}>
                    <Typography variant="h6" sx={{fontWeight:'bold'}}>Date:</Typography>
                    <Typography variant="h6" sx={{ml:'2px'}}>{formatObj.format(new Date(data.createDate))}</Typography>
                </Box>
                <Box sx={{display:'flex'}}>
                    <Typography variant="h6" sx={{fontWeight:'bold'}}>Inspector:</Typography>
                    <Typography variant="h6" sx={{ml:'2px'}}>{data.appUser.firstName + ' ' + data.appUser.lastName}</Typography>
                </Box>
                <Box sx={{display:'flex'}}>
                    <Typography variant="h6" sx={{fontWeight:'bold'}}>Reel Size:</Typography>
                    <Typography variant="h6" sx={{ml:'2px'}}>{data.reel.reelTypeName}</Typography>
                </Box>
                <Box sx={{display:'flex'}}>
                    <Typography variant="h6" sx={{fontWeight:'bold'}}>Reel Serial Number:</Typography>
                    <Typography variant="h6" sx={{ml:'2px'}}>{data.reel.serialNumber}</Typography>
                </Box>
            </Stack>

            <Stack spacing={1} sx={{pt:2}}>
                <Grid container sx={{p:1, border:'1px solid #e2e8f0', borderRadius:'5px'}}>          
                    <Grid item xs={12} sm={5} sx={{textAlign:'left'}}>
                        <Fade in>
                            <Box component="img" src={FRI1} sx={{ px:.25, cursor:'pointer', width:"75px" }} onClick={() => {setZoom('FRI1');}} />
                        </Fade>

                        {/* <Image src={FRI1}  showLoading sx={{px:.25, cursor:'pointer'}} width={75} onClick={() => {setZoom('FRI1');}} /> */}
                    </Grid>
                    <Grid item xs={8} sm={4} sx={{textAlign:'left', px:{xs:0, sm:1}}}>
                        <Typography variant='body1' sx={{fontWeight:'bold'}}>Cracks in the ribs of the flange</Typography>
                    </Grid>
                    <Grid item xs={4} sm={3}>
                        <Grid container>
                            <Grid item xs={12} sx={{textAlign:'center'}}>
                                {
                                    data.flangeRibCracks===1
                                    ?
                                        <Box sx={{backgroundColor: 'green', color:'white', borderRadius:'5px'}}>
                                            <Typography>Pass</Typography>
                                        </Box>
                                    :
                                        data.flangeRibCracks===-1
                                        ?
                                            <Box sx={{backgroundColor: 'red', color:'white', borderRadius:'5px'}}>
                                                <Typography>Fail</Typography>
                                            </Box>
                                        :
                                            ''
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign:'left', pt:1}}>
                        <Typography>Notes:</Typography>
                        <Typography>{data.flangeRibCracksNotes}</Typography>
                    </Grid>
                </Grid>

                <Grid container sx={{p:1, border:'1px solid #e2e8f0', borderRadius:'5px'}}>          
                    <Grid item xs={12} sm={5} sx={{textAlign:'left'}}>
                        <Fade in>
                            <Box component="img" src={FRI1} sx={{ px:.25, cursor:'pointer', width:"75px" }} onClick={() => {setZoom('FRI2');}} />
                        </Fade>                        
                        {/* <Image src={FRI2}  showLoading sx={{px:.25, cursor:'pointer'}} width={75} onClick={() => {setZoom('FRI2');}} /> */}
                    </Grid>
                    <Grid item xs={8} sm={4} sx={{textAlign:'left', px:{xs:0, sm:1}}}>
                        <Typography variant='body1' sx={{fontWeight:'bold'}}>Abrasions in the flange</Typography>
                    </Grid>
                    <Grid item xs={4} sm={3}>
                        <Grid container>
                            <Grid item xs={12} sx={{textAlign:'center'}}>
                                {
                                    data.flangeAbrasions===1
                                    ?
                                        <Box sx={{backgroundColor: 'green', color:'white', borderRadius:'5px'}}>
                                            <Typography>Pass</Typography>
                                        </Box>
                                    :
                                        data.flangeAbrasions===-1
                                        ?
                                            <Box sx={{backgroundColor: 'red', color:'white', borderRadius:'5px'}}>
                                                <Typography>Fail</Typography>
                                            </Box>
                                        :
                                            ''
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign:'left', pt:4}}>
                        <Typography>Notes:</Typography>
                        <Typography>{data.flangeAbrasionsNotes}</Typography>
                    </Grid>
                </Grid>

                <Grid container sx={{p:1, border:'1px solid #e2e8f0', borderRadius:'5px'}}>          
                    <Grid item xs={12} sm={5} sx={{textAlign:'left'}}>
                        <Fade in>
                            <Box component="img" src={FRI1} sx={{ px:.25, cursor:'pointer', width:"75px" }} onClick={() => {setZoom('FRI3');}} />
                        </Fade>
                        {/* <Image src={FRI3}  showLoading sx={{px:.25, cursor:'pointer'}} width={75} onClick={() => {setZoom('FRI3');}} /> */}
                    </Grid>
                    <Grid item xs={8} sm={4} sx={{textAlign:'left', px:{xs:0, sm:1}}}>
                        <Typography variant='body1' sx={{fontWeight:'bold'}}>Burs on the lagging tire</Typography>
                    </Grid>
                    <Grid item xs={4} sm={3}>
                        <Grid container>
                            <Grid item xs={12} sx={{textAlign:'center'}}>
                                {
                                    data.laggingTireBurs===1
                                    ?
                                        <Box sx={{backgroundColor: 'green', color:'white', borderRadius:'5px'}}>
                                            <Typography>Pass</Typography>
                                        </Box>
                                    :
                                        data.laggingTireBurs===-1
                                        ?
                                            <Box sx={{backgroundColor: 'red', color:'white', borderRadius:'5px'}}>
                                                <Typography>Fail</Typography>
                                            </Box>
                                        :
                                            ''
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign:'left', pt:4}}>
                        <Typography>Notes:</Typography>
                        <Typography>{data.laggingTireBursNotes}</Typography>
                    </Grid>
                </Grid>

                <Grid container sx={{p:1, border:'1px solid #e2e8f0', borderRadius:'5px'}}>          
                    <Grid item xs={12} sm={5} sx={{textAlign:'left'}}>
                        <Box sx={{display:'flex'}}>
                            <Fade in>
                                <Box component="img" src={FRI41} sx={{ px:.25, cursor:'pointer', width:"75px" }} onClick={() => {setZoom('FRI41');}} />
                            </Fade>                        
                            <Fade in>
                                <Box component="img" src={FRI42} sx={{ px:.25, cursor:'pointer', width:"75px" }} onClick={() => {setZoom('FRI42');}} />
                            </Fade>                        
                            <Fade in>
                                <Box component="img" src={FRI43} sx={{ px:.25, cursor:'pointer', width:"75px" }} onClick={() => {setZoom('FRI43');}} />
                            </Fade>                            

                            {/* <Image src={FRI41} showLoading sx={{px:.25, cursor:'pointer'}} width={75} onClick={() => {setZoom('FRI41');}} />
                            <Image src={FRI42} showLoading sx={{px:.25, cursor:'pointer'}} width={75} onClick={() => {setZoom('FRI42');}} />
                            <Image src={FRI43} showLoading sx={{px:.25, cursor:'pointer'}} width={75} onClick={() => {setZoom('FRI43');}} /> */}
                        </Box>
                    </Grid>
                    <Grid item xs={8} sm={4} sx={{textAlign:'left', px:{xs:0, sm:1}}}>
                        <Typography variant='body1' sx={{fontWeight:'bold'}}>Damages to crossarms and arbor</Typography>
                    </Grid>
                    <Grid item xs={4} sm={3}>
                        <Grid container>
                            <Grid item xs={12} sx={{textAlign:'center'}}>
                                {
                                    data.crossarmArborDamage===1
                                    ?
                                        <Box sx={{backgroundColor: 'green', color:'white', borderRadius:'5px'}}>
                                            <Typography>Pass</Typography>
                                        </Box>
                                    :
                                        data.crossarmArborDamage===-1
                                        ?
                                            <Box sx={{backgroundColor: 'red', color:'white', borderRadius:'5px'}}>
                                                <Typography>Fail</Typography>
                                            </Box>
                                        :
                                            ''
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign:'left', pt:4}}>
                        <Typography>Notes:</Typography>
                        <Typography>{data.crossarmArborDamageNotes}</Typography>
                    </Grid>
                </Grid>          

                <Grid container sx={{p:1, border:'1px solid #e2e8f0', borderRadius:'5px'}}>          
                    <Grid item xs={12} sm={5} sx={{textAlign:'left'}}>
                        <Box sx={{display:'flex'}}>
                            <Fade in>
                                <Box component="img" src={FRI5} sx={{ px:.25, cursor:'pointer', width:"75px" }} onClick={() => {setZoom('FRI5');}} />
                            </Fade>                        

                            {/* <Image src={FRI5} showLoading sx={{px:.25, cursor:'pointer'}} width={75} onClick={() => {setZoom('FRI5');}} /> */}
                        </Box>
                    </Grid>
                    <Grid item xs={8} sm={4} sx={{textAlign:'left', px:{xs:0, sm:1}}}>
                        <Typography variant='body1' sx={{fontWeight:'bold'}}>Straightness of Reel</Typography>
                    </Grid>
                    <Grid item xs={4} sm={3}>
                        <Grid container>
                            <Grid item xs={12} sx={{textAlign:'center'}}>
                                {
                                    data.reelStraightness===1
                                    ?
                                        <Box sx={{backgroundColor: 'green', color:'white', borderRadius:'5px'}}>
                                            <Typography>Pass</Typography>
                                        </Box>
                                    :
                                        data.reelStraightness===-1
                                        ?
                                            <Box sx={{backgroundColor: 'red', color:'white', borderRadius:'5px'}}>
                                                <Typography>Fail</Typography>
                                            </Box>
                                        :
                                            ''
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign:'left', pt:4}}>
                        <Typography>Notes:</Typography>
                        <Typography>{data.reelStraightnessNotes}</Typography>
                    </Grid>
                </Grid>      

                <Grid container sx={{p:1, border:'1px solid #e2e8f0', borderRadius:'5px'}}>          
                    <Grid item xs={12} sm={5} sx={{textAlign:'left'}}>
                        <Box sx={{display:'flex'}}>
                            <Fade in>
                                <Box component="img" src={FRI61} sx={{ px:.25, cursor:'pointer', width:"75px" }} onClick={() => {setZoom('FRI61');}} />
                            </Fade>                        

                            {/* <Image src={FRI61} showLoading sx={{px:.25, cursor:'pointer'}} width={75} onClick={() => {setZoom('FRI61');}} /> */}
                        </Box>
                    </Grid>
                    <Grid item xs={8} sm={4} sx={{textAlign:'left', px:{xs:0, sm:1}}}>
                        <Typography variant='body1' sx={{fontWeight:'bold'}}>Two D-rings in the starter pocket</Typography>
                    </Grid>
                    <Grid item xs={4} sm={3}>
                        <Grid container>
                            <Grid item xs={12} sx={{textAlign:'center'}}>
                                {
                                    data.dRings===1
                                    ?
                                        <Box sx={{backgroundColor: 'green', color:'white', borderRadius:'5px'}}>
                                            <Typography>Pass</Typography>
                                        </Box>
                                    :
                                        data.dRings===-1
                                        ?
                                            <Box sx={{backgroundColor: 'red', color:'white', borderRadius:'5px'}}>
                                                <Typography>Fail</Typography>
                                            </Box>
                                        :
                                            ''
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign:'left', pt:4}}>
                        <Typography>Notes:</Typography>
                        <Typography>{data.dRingsNotes}</Typography>
                    </Grid>
                </Grid> 

                <Grid container sx={{p:1, border:'1px solid #e2e8f0', borderRadius:'5px'}}>          
                    <Grid item xs={12} sm={5} sx={{textAlign:'left'}}>
                        <Fade in>
                            <Box component="img" src={FRI62} sx={{ px:.25, cursor:'pointer', width:"75px" }} onClick={() => {setZoom('FRI62');}} />
                        </Fade>                        


                        {/* <Image src={FRI62} showLoading sx={{px:.25, cursor:'pointer'}} width={75} onClick={() => {setZoom('FRI62');}} /> */}
                    </Grid>
                    <Grid item xs={8} sm={4} sx={{textAlign:'left', px:{xs:0, sm:1}}}>
                        <Typography variant='body1' sx={{fontWeight:'bold'}}>Two gussets on crossarm</Typography>
                    </Grid>
                    <Grid item xs={4} sm={3}>
                        <Grid container>
                            <Grid item xs={12} sx={{textAlign:'center'}}>
                                {
                                    data.gussets===1
                                    ?
                                        <Box sx={{backgroundColor: 'green', color:'white', borderRadius:'5px'}}>
                                            <Typography>Pass</Typography>
                                        </Box>
                                    :
                                        data.gussets===-1
                                        ?
                                            <Box sx={{backgroundColor: 'red', color:'white', borderRadius:'5px'}}>
                                                <Typography>Fail</Typography>
                                            </Box>
                                        :
                                            ''
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign:'left', pt:4}}>
                        <Typography>Notes:</Typography>
                        <Typography>{data.gussetsNotes}</Typography>
                    </Grid>
                </Grid> 


                <Grid container sx={{p:1, border:'1px solid #e2e8f0', borderRadius:'5px'}}>          
                    <Grid item xs={12} sm={5} sx={{textAlign:'left'}}>
                    </Grid>
                    <Grid item xs={8} sm={4} sx={{textAlign:'left', px:{xs:0, sm:1}}}>
                        <Typography variant='body1' sx={{fontWeight:'bold'}}>Is the drum stitch welded to the flange on both sides</Typography>
                    </Grid>
                    <Grid item xs={4} sm={3}>
                        <Grid container>
                            <Grid item xs={12} sx={{textAlign:'center'}}>
                                {
                                    data.drumSticthWeld===1
                                    ?
                                        <Box sx={{backgroundColor: 'green', color:'white', borderRadius:'5px'}}>
                                            <Typography>Pass</Typography>
                                        </Box>
                                    :
                                        data.drumSticthWeld===-1
                                        ?
                                            <Box sx={{backgroundColor: 'red', color:'white', borderRadius:'5px'}}>
                                                <Typography>Fail</Typography>
                                            </Box>
                                        :
                                            ''
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{textAlign:'left', pt:4}}>
                        <Typography>Notes:</Typography>
                        <Typography>{data.drumSticthWeldNotes}</Typography>
                    </Grid>
                </Grid>                 
            </Stack>            
        </Box>
        </>
    );
}
